/**
 * Domain detection utilities for multi-brand support.
 * Figmafolio (portfolio hosting) and Aero (user testing, responsive)
 * share the same app but are served on different domains.
 */
export function isAeroDomain() {
  const host = window.location.host;
  return host.includes('aeroapp.ai');
}

export function isFigmafolioDomain() {
  const host = window.location.host;
  return (
    host.includes('figmafolio.com') ||
    host.includes('figma-app-tau.vercel.app') ||
    host === 'localhost:3000'
  );
}

// Returns the correct base URL for generating links on the current domain
export function getBaseUrl() {
  if (isAeroDomain()) return 'https://aeroapp.ai';
  return 'https://app.figmafolio.com';
}

// Canonical public URL for a project, based on its content type.
//
// `brand` ('aero' | 'figmafolio') is optional. When provided it selects the
// host, so a caller that renders rows for the OTHER brand than the page it is
// loaded on (e.g. the admin dashboard's brand toggle) still gets the correct
// address. When omitted the host follows the current domain (isAeroDomain /
// getBaseUrl), preserving the existing behavior for every other caller.
export function buildSiteUrl({ generatedUrl, type, customDomain, brand }) {
  const isAero = brand ? brand === 'aero' : isAeroDomain();
  if (type === 'html') {
    // HTML custom-domain serving is not wired in api/site.js yet; always use the subdomain.
    const host = isAero ? 'aeroapp.ai' : 'figmafolio.com';
    return `https://${generatedUrl}.${host}`;
  }
  if (customDomain) {
    return `https://${customDomain}`;
  }
  const base = brand ? (isAero ? 'https://aeroapp.ai' : 'https://app.figmafolio.com') : getBaseUrl();
  return `${base}/${generatedUrl}`;
}

// Display name for the current brand context
export function getBrandName() {
  if (isAeroDomain()) return 'Aero';
  return 'Figmafolio';
}

// Is this any recognized app domain (vs a user's custom domain)?
export function isAppDomain() {
  return isAeroDomain() || isFigmafolioDomain();
}
